import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { getGroups } from '@cervotech/utils/regex';

const toTitleCase = (value: string) => {
  const quotesGroups = getGroups(value, /["«](?:(?!["«»]).)+["»]/gm);
  quotesGroups.forEach((group, index) => {
    value = value.replace(group.match, `{{${index}}}`);
  });
  value =
    value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase();
  quotesGroups.forEach((group, index) => {
    value = value.replace(`{{${index}}}`, group.match);
  });
  return value;
};

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, args?: 'all'): string {
    if (value) {
      if (args === 'all') {
        return value.split(' ').map(toTitleCase).join(' ');
      } else {
        return toTitleCase(value);
      }
    }
    return value;
  }
}

@NgModule({
  declarations: [CapitalizePipe],
  exports: [CapitalizePipe],
  imports: [CommonModule],
})
export class CapitalizePipeModule {}
